import styled from 'styled-components';
const transitionDuration = '200ms';
export const Time = styled.span `
    color: ${({ theme }) => { var _a; return ((_a = theme === null || theme === void 0 ? void 0 : theme.color) === null || _a === void 0 ? void 0 : _a.textPrimary) || 'white'; }};
    transition: opacity ${transitionDuration}, visibility ${transitionDuration};
    opacity: ${({ isVolumeOpened }) => (isVolumeOpened ? 0 : 1)};
    visibility: ${({ isVolumeOpened }) => (isVolumeOpened ? 'hidden' : 'visible')};
`;
//# sourceMappingURL=index.js.map